import React, { useState, useEffect, useMemo } from "react"
import CalendarPicker from '@mui/lab/CalendarPicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import PickersDay from '@mui/lab/PickersDay';
import ruLocale from 'date-fns/locale/ru';
import styles from "./Calendar.module.css"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { fetchAllEvents } from "./calendarSlice";
import Event from "./components/Event";
import moment from 'moment'
import CircularProgress from '@mui/material/CircularProgress';
import {
    buildMarkedDateSet,
    filterEventsByCalendarMode,
} from "../../utils/calendarEventUtils";

/** 'date' | 'new' | 'old' — matches mobile day / prev / next modes */
const Calendar = () => {
    const minDate = new Date('2010-01-01T00:00:00.000')
    const navigation = useNavigate()
    const [date, setDate] = useState(new Date())
    const [eventsGroup, setEventsGroup] = useState('date')
    const eventsList = useSelector(state => state.calendarSlice.eventsList || [])
    const isLoaded = useSelector(state => state.calendarSlice.isLoaded)
    const dispatch = useDispatch()

    const calendarMode = useMemo(() => {
        if (eventsGroup === 'new') return 'next'
        if (eventsGroup === 'old') return 'prev'
        return 'day'
    }, [eventsGroup])

    const selectedDateStr = useMemo(() => moment(date).format('YYYY-MM-DD'), [date])

    const filteredEvents = useMemo(
        () => filterEventsByCalendarMode(eventsList, selectedDateStr, calendarMode),
        [eventsList, selectedDateStr, calendarMode],
    )

    const markedDates = useMemo(() => buildMarkedDateSet(eventsList), [eventsList])

    const dateHandler = (newDate) => {
        setDate(newDate)
        setEventsGroup('date')
    }

    const switchHandler = (e) => {
        const type = e.target.id
        const checked = e.target.checked
        if (type === 'newEvents') {
            if (checked) {
                setEventsGroup('new')
            } else {
                setEventsGroup('date')
            }
        } else if (type === 'oldEvents') {
            if (checked) {
                setEventsGroup('old')
            } else {
                setEventsGroup('date')
            }
        }
    }

    const allEvents = filteredEvents.length > 0 ? filteredEvents.map((event) => {
        const goTo = () => {
            navigation(`/calendar/${event.id}`)
        }
        return <div onClick={goTo} key={event.id}><Event data={event} /></div>
    }) : <div style={{ paddingTop: '20px', marginLeft: '42px' }}>Нет событий</div>

    useEffect(() => {
        dispatch(fetchAllEvents())
    }, [dispatch])

    return (
        <>
            <>
                <section className="main">
                    <div className="content-wrapper">
                        <div className="page-title-container">
                            <h1 className="page-title ">
                                Календарь
                            </h1>
                        </div>
                        <div className={styles.wrapper}>
                            <div style={{ display: 'flex', alignItems: 'center' }}  >
                                <LocalizationProvider locale={ruLocale} dateAdapter={AdapterDateFns}>
                                    <CalendarPicker
                                        date={date}
                                        minDate={minDate}
                                        onChange={dateHandler}
                                        renderDay={(day, selectedDate, pickersDayProps) => {
                                            const dayStr = moment(day).format('YYYY-MM-DD')
                                            const hasEvent = markedDates.has(dayStr)
                                            return (
                                                <PickersDay
                                                    {...pickersDayProps}
                                                    sx={{
                                                        borderRadius: '50%',
                                                        ...(hasEvent && {
                                                            border: '1px solid #EF2E25',
                                                            '&.Mui-selected': {
                                                                backgroundImage: 'linear-gradient(0.56turn, #f36d52, #ef2e25)',
                                                                color: '#fff',
                                                            },
                                                        }),
                                                    }}
                                                />
                                            )
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div style={{ width: '100%' }}>
                                <div style={{ marginBottom: '10px' }} className="customcb">
                                    <input
                                        checked={eventsGroup === 'new'}
                                        onChange={switchHandler}
                                        type="checkbox"
                                        value="1"
                                        id="newEvents"
                                        name=""
                                    />
                                    <label className="inner" htmlFor="newEvents"></label>
                                    <label className="outer" htmlFor="newEvents">наступающие мероприятия</label>
                                </div>
                                <div style={{marginBottom: '20px'}} className="customcb">
                                    <input
                                        checked={eventsGroup === 'old'}
                                        onChange={switchHandler}
                                        type="checkbox"
                                        value="1"
                                        id="oldEvents"
                                        name=""
                                    />
                                    <label className="inner" htmlFor="oldEvents"></label>
                                    <label className="outer" htmlFor="oldEvents">прошедшие мероприятия</label>
                                </div>
                                {isLoaded ? allEvents : <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '50px' }}><CircularProgress color="inherit" /></div>}
                            </div>
                        </div>
                    </div>
                </section>
            </>
        </>
    )
}
export default Calendar
